import { useEffect, useState } from 'react';

export const useMousePosition = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const eventSet = (e: any) => setPosition({ x: e.clientX, y: e.clientY });
        window.addEventListener('mousemove', eventSet);
        // remove o eventListener quando o hook deixa de ser usado
        return () => {
            window.removeEventListener('mousemove', eventSet);
        };
    }, []);

    return position;
};
